import $ from "jquery";
export function addEducation(education) {
	$('#education').append(`
		<ul>
			<li> 
				<div class='date'>
					${education.date}
				</div>
				<div class='name'>
					${education.school}
				</div>
			</li>
		</ul>
	`);
}